// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mp-cover-container-left {
    position: relative;
    width: 20%;
    margin-left: 20px;
    height: 200px; /* Adjust height as needed */
    overflow: hidden;
    border-radius: 10px;
    background: none;
    justify-items: center;
    align-items: center;
}

.mp-cover-container-right {
    position: relative;
    width: 25%;
    height: 70px; /* Adjust height as needed */
    overflow: hidden;
    border-radius: 10px;
    background: none;
    margin-top: 100px;
    justify-content: center;
    justify-items: center;
    align-items: center;
    align-content: center;
    display: flex;
    flex-direction: row;
}

.mp-profile-photo {
    margin-bottom: 40px;
    width: 150px;
    height: 150px;
    border-radius: 50%;
    border-width: 3px;
    align-items: center;    
}

.mp-cover-container-button {
    background: gray;
    border-color: white;
    color: black;
}

.mp-cover-container-button:hover {
    border-color: black;
}

.mp-cover-container-User {
    position: relative;
    width: 50%;
    height: 60px; /* Adjust height as needed */
    margin-top: 100px;
    justify-content: center;
    justify-items: center;
    align-items: center;
    align-content: center;
    color: black;
}

.mp-user-text-props {
    font-size: 20px;
    color: black;
}`, "",{"version":3,"sources":["webpack://./src/components/Pages/OverlayPage/Styles/CoverImageUploader.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,UAAU;IACV,iBAAiB;IACjB,aAAa,EAAE,4BAA4B;IAC3C,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY,EAAE,4BAA4B;IAC1C,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;IACvB,qBAAqB;IACrB,mBAAmB;IACnB,qBAAqB;IACrB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY,EAAE,4BAA4B;IAC1C,iBAAiB;IACjB,uBAAuB;IACvB,qBAAqB;IACrB,mBAAmB;IACnB,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,YAAY;AAChB","sourcesContent":[".mp-cover-container-left {\n    position: relative;\n    width: 20%;\n    margin-left: 20px;\n    height: 200px; /* Adjust height as needed */\n    overflow: hidden;\n    border-radius: 10px;\n    background: none;\n    justify-items: center;\n    align-items: center;\n}\n\n.mp-cover-container-right {\n    position: relative;\n    width: 25%;\n    height: 70px; /* Adjust height as needed */\n    overflow: hidden;\n    border-radius: 10px;\n    background: none;\n    margin-top: 100px;\n    justify-content: center;\n    justify-items: center;\n    align-items: center;\n    align-content: center;\n    display: flex;\n    flex-direction: row;\n}\n\n.mp-profile-photo {\n    margin-bottom: 40px;\n    width: 150px;\n    height: 150px;\n    border-radius: 50%;\n    border-width: 3px;\n    align-items: center;    \n}\n\n.mp-cover-container-button {\n    background: gray;\n    border-color: white;\n    color: black;\n}\n\n.mp-cover-container-button:hover {\n    border-color: black;\n}\n\n.mp-cover-container-User {\n    position: relative;\n    width: 50%;\n    height: 60px; /* Adjust height as needed */\n    margin-top: 100px;\n    justify-content: center;\n    justify-items: center;\n    align-items: center;\n    align-content: center;\n    color: black;\n}\n\n.mp-user-text-props {\n    font-size: 20px;\n    color: black;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
